import React from "react"
import SaleStage from "../components/SaleStage"

class Step7SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { houseTurnoverRto={} } = (client && client.stages_of_sale) || {};

        const {
            clearedTenPercentMoveInFee,
            withOccupancyPermit,
            signedNotarizedAffidavitOfFinalAcceptanceFile,
            signedNotarizedAffidavitOfFinalAcceptanceDate,
            signedMoveInAuthorityAndMoveInClearanceFile,
            signedMoveInAuthorityAndMoveInClearanceDate,
            signedLeaseAgreementFile,
            signedLeaseAgreementDate,
            pdvsOfRentalMonthlyFee,
            isCompleted,
            completionDate,
            others=[]
        } = houseTurnoverRto;

        const step7Fields = [
            { key: 'clearedTenPercentMoveInFee', type: 'toggle', label: 'Cleared Ten Percent Move-in Fee', value: clearedTenPercentMoveInFee},
            { key: 'withOccupancyPermit', type: 'toggle', label: 'With Occupancy Permit', value: withOccupancyPermit},
            { key: 'signedNotarizedAffidavitOfFinalAcceptanceFile', type: 'file', label: 'Signed Notarized Affidavit Of Final Acceptance File', value: signedNotarizedAffidavitOfFinalAcceptanceFile},
            { key: 'signedNotarizedAffidavitOfFinalAcceptanceDate', type: 'date', label: 'Signed Notarized Affidavit Of Final Acceptance Date', value: signedNotarizedAffidavitOfFinalAcceptanceDate},
            { key: 'signedMoveInAuthorityAndMoveInClearanceFile', type: 'file', label: 'Signed Move In Authority And Move In Clearance File', value: signedMoveInAuthorityAndMoveInClearanceFile},
            { key: 'signedMoveInAuthorityAndMoveInClearanceDate', type: 'date', label: 'Signed Move In Authority And Move In Clearance Date', value: signedMoveInAuthorityAndMoveInClearanceDate},
            { key: 'signedLeaseAgreementFile', type: 'file', label: 'Signed Lease Agreement File', value: signedLeaseAgreementFile},
            { key: 'signedLeaseAgreementDate', type: 'date', label: 'Signed Lease Agreement Date', value: signedLeaseAgreementDate},
            { key: 'pdvsOfRentalMonthlyFee', type: 'toggle', label: 'PDCs Of Rental Monthly Fee', value: pdvsOfRentalMonthlyFee},
        ]

        return (
            !!client ? <SaleStage 
                title="House Turnover RTO"
                fields={step7Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="houseTurnoverRto"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step7SS
